import { dataLayerPush } from '@libs/analytics';

const siteSection = 'my account | addresses';

export const trackAddNewAddress = () => {
    dataLayerPush({ event: 'add_new_address', site_section: siteSection });
};

export const trackEditAddress = () => {
    dataLayerPush({ event: 'edit_address', site_section: siteSection });
};

export const trackRemoveAddress = () => {
    dataLayerPush({ event: 'remove_address', site_section: siteSection });
};

export const trackSaveAddress = (type: 'new' | 'edit') => {
    dataLayerPush({ event: 'save_address', save_type: type, site_section: siteSection });
};

export const trackErrorAddress = (message: string) => {
    dataLayerPush({ event: 'error', error_message: message, site_section: siteSection });
};
